import { SETTLEMENT_STATUS } from "./SettlementStatus.enum";

const allowedStatesToSendOrReceive = [
  SETTLEMENT_STATUS.LiquidacionGenerada,
  SETTLEMENT_STATUS.ASubsanar,
  SETTLEMENT_STATUS.PendienteDeSubsanacion,
  SETTLEMENT_STATUS.EnProceso,
];

const allowedStatesToViewDifferential = [
  SETTLEMENT_STATUS.Enviada,
  SETTLEMENT_STATUS.EnVerificacion,
];

export const isInCreate = (current: SETTLEMENT_STATUS): boolean => {
  return (
    current === SETTLEMENT_STATUS.LiquidacionGenerada || current === SETTLEMENT_STATUS.EnProceso
  );
};

export const isInSubsanar = (current: SETTLEMENT_STATUS): boolean => {
  return (
    current === SETTLEMENT_STATUS.ASubsanar || current === SETTLEMENT_STATUS.PendienteDeSubsanacion
  );
};

export const isSendForwardStatus = (current: SETTLEMENT_STATUS): boolean => {
  return allowedStatesToSendOrReceive.includes(current);
};

export const isReciveForwardStatus = (current: SETTLEMENT_STATUS): boolean => {
  return allowedStatesToViewDifferential.includes(current);
};

export const isToMarkAsEnVerificacion = (current: string): boolean => {
  return current === SETTLEMENT_STATUS.Enviada;
};
